import React from "react";
import { initialOptions } from "../constants";

const HomePage = ({ onStartChat }) => {
  return (
    <div className="h-full flex flex-col justify-center items-start gap-4 sm:gap-6 px-2 sm:px-4">
      <div className="w-full">
        <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-black mb-3 leading-tight text-center">
          Welcome to Home First Finance
        </h1>
        <p className="text-gray-600 text-xs sm:text-sm md:text-base mb-6 leading-relaxed text-center" style={{ wordWrap: 'break-word', overflowWrap: 'break-word', hyphens: 'auto' }}>
          Hi I'm NAOL, your Home Loan Guide at HomeFirst. I'm here to help you with loans, calculations, and quick support. How can I assist you today?
        </p>
      </div>
      <div className="flex flex-col gap-3 w-full items-start">
        {initialOptions.map((option, index) => (
          <button
            key={index}
            onClick={() => onStartChat(option)}
            className="bg-white rounded-xl px-4 py-3 text-sm text-black text-left hover:bg-[#E7E5E1] transition-colors shadow-sm border border-gray-100 flex items-center gap-2 w-full"
          >
            {option === "New Loan Inquiry" && (
              <img
                src="/NewLoan.svg"
                alt="New Loan Inquiry"
                className="w-6 h-6 object-contain"
              />
            )}
            {option === "Existing Customer" && (
              <img
                src="/existinhUser.svg"
                alt="Existing Customer"
                className="w-6 h-6 object-contain"
              />
            )}
            {option === "Calculators" && (
              <img
                src="/calculators.svg"
                alt="Calculators"
                className="w-6 h-6 object-contain"
              />
            )}
            {option === "FAQ" && (
              <img
                src="/FAQ.svg"
                alt="FAQ"
                className="w-6 h-6 object-contain"
              />
            )}
            {option === "Contact Us" && (
              <img
                src="/contactUs.svg"
                alt="Contact Us"
                className="w-6 h-6 object-contain"
              />
            )}
            <span>{option}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default HomePage;

